import { apiClient } from '@/shared/lib/axios';
import { Insurer, InsurerQuery } from '@/types/admin-insurer';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

type Response<T> = {
  data: {
    data: T[];
    meta: {
      total: number;
      per_page: number;
      current_page: number;
      last_page: number;
    };
    links: {
      prev: string | null;
      next: string | null;
    };
  };
};

export const getInsurerList = async (
  siteType: string | null,
  query?: InsurerQuery
): Promise<Response<Insurer>> => {
  const response = await apiClient.get<Response<Insurer>>(`/admin/${siteType}/insurers`, {
    params: query,
  });
  return response.data;
};

export const useAdminInsurerList = (query: InsurerQuery) => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';

  return useQuery({
    queryKey: ['insurers', currentSite, query],
    queryFn: () => getInsurerList(currentSite, query),
    select: res => res.data,
  });
};
